export function hasMsisdn(msisdn) {
  if (msisdn === null || msisdn === undefined) {
    return false
  }
  return String(msisdn).trim().length > 0
}

/** Pretty-print MSISDN for UI (e.g. +852 9123 4567). */
export function formatMsisdn(msisdn) {
  if (!hasMsisdn(msisdn)) {
    return ''
  }

  const raw = String(msisdn).trim()
  const digits = raw.replace(/\D/g, '')
  if (!digits) {
    return raw
  }

  // Hong Kong: country code 852 + 8-digit local number
  if (digits.startsWith('852') && digits.length === 11) {
    const local = digits.slice(3)
    return `+852 ${local.slice(0, 4)} ${local.slice(4)}`
  }

  if (digits.length >= 10) {
    return `+${digits}`
  }

  return raw.startsWith('+') ? raw : digits
}

/** E.164 format for dial / clipboard (e.g. +85291234567). */
export function formatMsisdnCopy(msisdn) {
  if (!hasMsisdn(msisdn)) {
    return ''
  }

  const digits = String(msisdn).replace(/\D/g, '')
  return digits ? `+${digits}` : ''
}

export const formatMsisdnDisplay = formatMsisdn
